module.exports = __webpack_public_path__ + "static/media/Icon_F5B076.40dd4c95.png";